export class ChangeCategoryDialogController {
    public static $inject: string[] = [
        "$mdDialog",
        "$mdMedia",
        "categoryService",
        "nbElemSelected",
        "utilsService"
    ];

    public categories;
    public searchText;
    public selectedCategory;

    constructor(
        private $mdDialog: ng.material.IDialogService,
        public $mdMedia: ng.material.IMedia,
        categoryService,
        public nbElemSelected: number,
        private utilsService
    ) {
        this.categories = categoryService.getCategories();
    }

    public apply() {
        if (this.selectedCategory) {
            this.$mdDialog.hide(this.selectedCategory);
        }
    }

    public close() {
        this.$mdDialog.hide();
    }

    public search() {
        return this.searchText ? this.categories.filter(
            category => {
                return this.utilsService
                        .stringNormalize(category.name)
                        .includes(this.utilsService.stringNormalize(this.searchText));
            }) : this.categories;
    }
}
